import React from 'react';
import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { toUiPublishState, UI_PUBLISH_STATES } from '../../NewsQueueConstants';

export function publishedAlsoTargetMedias(article) {
    if (toUiPublishState(article?.publish_state) !== UI_PUBLISH_STATES.ACCEPTED) return [];

    const raw = article?.multi_publication_target_medias;
    if (!Array.isArray(raw)) return [];

    const seen = new Set();
    const medias = [];
    raw.forEach((value) => {
        const media = String(value ?? '').trim();
        if (!media || seen.has(media)) return;
        seen.add(media);
        medias.push(media);
    });
    return medias;
}

export default function PublishedAlsoToMedias({ medias = [], getTargetMediaLabel, sx }) {
    const intl = useIntl();
    if (!medias.length || typeof getTargetMediaLabel !== 'function') return null;

    return (
        <Box sx={sx}>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                {intl.formatMessage({ id: 'newsQueue.article.publishedAlsoToMedias' })}
            </Typography>
            {medias.map((media) => (
                <Typography key={media} variant="caption" color="text.secondary" component="div">
                    {getTargetMediaLabel(media)}
                </Typography>
            ))}
        </Box>
    );
}
